// Run fn after the browser has painted the current frame, so tracking never delays a tap's visible response.
// A hidden tab paints no frames (requestAnimationFrame waits until it's shown again), so there fn just waits a task.
export function afterPaint(fn) {
  if (typeof window === 'undefined' || window.__PRERENDER__) { fn(); return; }
  if (document.visibilityState === 'hidden') { setTimeout(fn, 0); return; }
  requestAnimationFrame(() => setTimeout(fn, 0));
}

export function pushNow(obj) {
  try { (window.dataLayer = window.dataLayer || []).push(obj); } catch (e) { /* analytics never strands the user */ }
}

export function pushAfterPaint(obj) {
  afterPaint(() => pushNow(obj));
}
